/* eslint semi: 1 */

import LocationIcon from './group-players-icon';
import { createApp } from 'vue';

/**
 * Generate custom icon based off a SVG tree defined
 * as a VUE component.
 * @param {*} params
 * @returns
 */
export const getCustomIconUrl = (params) => {
  // create a Vue element with required props

  if (!params.width) params.width = '47px';
  if (!params.height) params.height = '47px';
  if (!params.textColor) params.textColor = '#FFFFFF';

  let markerContainer = document.getElementById('markerContainer');
  if (!markerContainer) {
    markerContainer = document.createElement('div');
    markerContainer.id = 'markerContainer';
  }

  document.getElementById('app').appendChild(markerContainer);

  const app = createApp(LocationIcon, { params });
  // mount the component shadow DOM
  // get icon DOM element
  const vm = app.mount('#markerContainer');
  // generate an html string from an element
  const iconString = new XMLSerializer().serializeToString(vm.$el);

  // unmount after we get the element
  app.unmount();

  // generate a data url from a string
  return 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(iconString);
};

export const createCustomMarkerIcon = async (markerData) => {
  const createIconParams = {
    fillColor: markerData.iconProp.fillColor,
    strokeColor: markerData.iconProp.strokeColor,
    text: '',
    status: markerData.status,
    groupIcon: false,
    backgroundWithOpacity: {
      fillColor: markerData.iconProp.strokeColor,
      opacity: markerData.iconProp.backgroundWithOpacity ? markerData.iconProp.backgroundWithOpacity.opacity : '0.2'
    },
    iconClassName: markerData.iconProp.iconClassName ? markerData.iconProp.iconClassName : null
  };

  if (markerData.hideIcon) {
    createIconParams.noIcon = true;
    createIconParams.width = '0px';
    createIconParams.height = '0px';
  }

  // For Custom or grouped marker
  if (markerData.iconProp.groupIcon && (markerData.members && markerData.members.length)) {
    createIconParams.text = markerData.iconProp.text;
    createIconParams.groupIcon = true;
  }

  let iconScale = 47;
  // Adjust size for group icon
  if (createIconParams.groupIcon) {
    iconScale = 54;
    createIconParams.width = '54px';
    createIconParams.height = '54px';
  }

  const element = document.createElement('img');
  element.src = getCustomIconUrl(createIconParams);
  element.width = iconScale;
  element.height = iconScale;
  // NOTE: this adds an offset instead of deprecated `anchor` property of the marker
  element.style.transform = `translateY(${Math.floor(iconScale / 2)}px)`;
  return element;
};

/**
 * This is Marker Management pattern implementation based on an example by Google Maps API v3.x docs
 * https://developers.google.com/maps/documentation/javascript/examples/marker-remove
 * to manage markers on the screen.
 */
export default {
  data: {
    markers: []
  },
  getMarkers () {
    return this.data.markers;
  },
  async addMarker (map, markerData) {
    const { LatLng } = await google.maps.importLibrary('core');
    const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');

    const marker = new AdvancedMarkerElement({
      position: new LatLng(markerData.lat, markerData.lng),
      map,
      content: await createCustomMarkerIcon(markerData),
      gmpClickable: true
    });

    this.data.markers.push({ marker, data: markerData });
    return marker;
  },
  async remove (marker) {
    const { event } = await google.maps.importLibrary('core');
    marker.setMap(null);
    event.clearInstanceListeners(marker);
  },
  async reset () {
    for (const { marker } of this.data.markers) {
      await this.remove(marker);
    }
    this.data.markers = [];
  }
};
